"use strict";

var _regeneratorRuntime = require("/builds/zonotho/Zonotho-2-0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/builds/zonotho/Zonotho-2-0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/builds/zonotho/Zonotho-2-0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCanvasOptions = exports.getOrientation = exports.getSize = exports.getImages = void 0;

var EXIF = require("exif-js");

var readFile_1 = require("./readFile");

var readImage_1 = require("./readImage");

var options_1 = require("../options");

function getImages(_x) {
  return _getImages.apply(this, arguments);
}

function _getImages() {
  _getImages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(files) {
    var datas;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return readFile_1.getDataFromReadFile(files);

          case 2:
            datas = _context.sent;
            _context.next = 5;
            return Promise.all(datas.map(function (item) {
              return readImage_1.readImage(item);
            }));

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getImages.apply(this, arguments);
}

exports.getImages = getImages;

function getSize(width, height) {
  var maxSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : options_1.defaultOptions.maxSize;
  var parseWidth = maxSize < width ? maxSize : width;
  var parseHeight = maxSize < height ? maxSize : height;

  if (width > height) {
    return {
      width: parseWidth,
      height: height * (parseWidth / width)
    };
  }

  if (height > width) {
    return {
      width: width * (parseHeight / height),
      height: parseHeight
    };
  }

  return {
    width: parseWidth,
    height: parseHeight
  };
}

exports.getSize = getSize;

function getOrientation(img) {
  var orientation = 1; // @ts-ignore not string: https://github.com/exif-js/exif-js/pull/198

  EXIF.getData(img, function () {
    orientation = EXIF.getTag(img, 'Orientation');
  });
  return orientation;
}

exports.getOrientation = getOrientation;

function getCanvasOptions(width, height, orientation) {
  var options = {
    translate: {
      x: 0,
      y: 0
    },
    scale: {
      x: 1,
      y: 1
    },
    rotate: {
      angle: 0
    }
  };

  switch (orientation) {
    case 2:
      // horizontal flip
      return _objectSpread(_objectSpread({}, options), {}, {
        translate: _objectSpread(_objectSpread({}, options.translate), {}, {
          x: width
        }),
        scale: _objectSpread(_objectSpread({}, options.scale), {}, {
          x: -1
        })
      });

    case 3:
      // 180° rotate left
      return _objectSpread(_objectSpread({}, options), {}, {
        translate: {
          x: width,
          y: height
        },
        rotate: {
          angle: Math.PI
        }
      });

    case 4:
      // vertical flip
      return _objectSpread(_objectSpread({}, options), {}, {
        translate: _objectSpread(_objectSpread({}, options.translate), {}, {
          y: height
        }),
        scale: _objectSpread(_objectSpread({}, options.scale), {}, {
          y: -1
        })
      });

    case 5:
      // vertical flip + 90 rotate right
      return _objectSpread(_objectSpread({}, options), {}, {
        scale: _objectSpread(_objectSpread({}, options.scale), {}, {
          x: -1
        }),
        rotate: {
          angle: 90 * Math.PI / 180
        }
      });

    case 6:
      // 90° rotate right
      return _objectSpread(_objectSpread({}, options), {}, {
        translate: _objectSpread(_objectSpread({}, options.translate), {}, {
          x: width
        }),
        rotate: {
          angle: 90 * Math.PI / 180
        }
      });

    case 7:
      // horizontal flip + 90 rotate right
      return _objectSpread(_objectSpread({}, options), {}, {
        translate: {
          x: width,
          y: height
        },
        rotate: {
          angle: 90 * Math.PI / 180
        },
        scale: _objectSpread(_objectSpread({}, options.scale), {}, {
          y: -1
        })
      });

    case 8:
      // 90° rotate left
      return _objectSpread(_objectSpread({}, options), {}, {
        translate: _objectSpread(_objectSpread({}, options.translate), {}, {
          y: height
        }),
        rotate: {
          angle: -(90 * Math.PI) / 180
        }
      });

    default:
      return options;
  }
}

exports.getCanvasOptions = getCanvasOptions;